<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>

    <div class="row">
      <div class="col">
          <button class="btn btn-success btn-block" end clear style="margin-bottom: 1%"
          (click)="getLocation()"><mat-icon>place</mat-icon>Auto Fill From Map</button>
      </div>
    </div>
<div style="margin:2%;" >
<div class="panel panel-default">
<div class="panel-body">
<form  #f1="ngForm">
<div class="form-group">
<label for="addline1">Address Line 1</label>
<input type="text" name="addline1" id="addline1" [(ngModel)]="addl1" class="form-control" required>
</div>
<div class="form-group">
<label for="addline2">Address Line 2</label>
<input type="text" name="addline2" id="addline2" [(ngModel)]="addl2"class="form-control" required>
</div>
<div class="form-group">
<label for="cityid">City</label>
<select name="cityid" id="cityid" [(ngModel)]="cityid" class="form-control" required>
      <option value="1">Bangalore</option>
    </select>
</div>
<div class="form-group">
<label for="stateid">State</label>
<select name="stateid" id="stateid" [(ngModel)]="stateid" class="form-control" required>
      <option value="1">Karnataka</option>
    </select>
</div>
<div class="form-group">
<label for="countryid">Country</label>
<select name="countryid" id="stateid" [(ngModel)]="countryid" class="form-control" required>
      <option value="1">India</option>
    </select>
</div>
<div class="form-group">
<label for="pin">Pin</label>
<input type="pin" name="pin" id="pin" [(ngModel)]="pin" class="form-control" required>
</div>
<div class="form-group">
<label for="phne">Phone</label>
<input type="phone" name="phone" id="phone" [(ngModel)]="phone"  class="form-control" required>
</div>
<div class="row">
    <div class="col-sm-6 col-lg-6 col-xl-6">
        <button  class="btn btn-success btn-block" [disabled]="!f1.valid" (click)=" checkUpdateNeeded()" >Add Address</button>
    </div>
    <div class="col-sm-6 col-lg-6 col-xl-6">
        <button class="btn btn-success3 btn-block" (click)="cancel()">Cancel</button>
    </div>
</div>


</form>
</div>
</div>
